// services/trainingService.js
import api from "Common/Client/Interceptor";

export const getLearnerTrainings = async (learnerUserId, token, completed) => {
  try {
    const response = await api.get(
      `/Training/Learner/List?completed=${completed}&pageNumber=1&pageSize=30`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
        suppressErrorToast: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching learner trainings:", error);
    throw error;
  }
};

export const getNameList = async (learnerId, token) => {
  try {
    const response = await api.get(
      `/Training/Learner/Names-List`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
        suppressErrorToast: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching learner trainings:", error);
    throw error;
  }
};
